import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Table } from '@dixa/lib-shared-habla';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
const columnCount = 3;
export function LoadingRow({ asyncStatus, onRefreshItems, }) {
    return asyncStatus === 'failed' ? (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ colSpan: columnCount }, { children: ["Something went wrong...", _jsx(Button, Object.assign({ variant: "tertiary", onClick: onRefreshItems }, { children: "Try again" }))] })) })) : (_jsx(TableLoadingRow, { colSpan: columnCount }));
}
